import { useTranslation } from "react-i18next";
import "../styles/OrderCancel.css";

export default function OrderCancel() {
  const { t } = useTranslation();

  const backToCheckout = () => {
    window.location.replace("/checkout");
  };

  const viewCart = () => {
    window.location.replace("/cart");
  };

  return (
    <main className="order-cancel-page">
      <section className="order-cancel-container">
        <div className="order-cancel-icon">!</div>

        <h1>{t("orderCancel.title")}</h1>

        <p>{t("orderCancel.message")}</p>

        <div className="order-cancel-actions">
          <button
            type="button"
            onClick={backToCheckout}
          >
            {t("orderCancel.backToCheckout")}
          </button>

          <button
            type="button"
            className="order-cancel-secondary"
            onClick={viewCart}
          >
            {t("orderCancel.viewCart")}
          </button>
        </div>
      </section>
    </main>
  );
}